module.exports = __webpack_public_path__ + "static/media/search.7731637b.svg";